var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-grid',{ref:"toPodTable",attrs:{"highlight-hover-row":"","data":_vm.tableData,"toolbar-config":_vm.tableToolbar,"columns":_vm.tableColumns,"row-class-name":_vm.rowClassName,"loading":_vm.loading,"height":_vm.tableHeight,"size":"small","resizable":"","border":"","seq-config":{
      startIndex: (_vm.tablePage.curPage - 1) * _vm.tablePage.pageSize,
    },"row-id":"waybillDetailCode","checkboxConfig":{
      reserve: true,
      highlight: false,
    }},scopedSlots:_vm._u([{key:"toolbar_form",fn:function(){return [_vm._t("header")]},proxy:true},{key:"pager",fn:function(){return [_vm._t("pager")]},proxy:true},{key:"orderso",fn:function(ref){
    var row = ref.row;
return [_c('div',[_c('span',[_vm._v(_vm._s(row.orderSoNo ? row.orderSoNo : '--'))])])]}},{key:"orderStatus",fn:function(ref){
    var row = ref.row;
return [_c('el-tag',{attrs:{"size":"mini","type":row.orderStatus === 'N'
            ? 'success'
            : row.orderStatus === 'Y'
            ? 'light'
            : 'warning'}},[_vm._v(" "+_vm._s(row.orderStatusName)+" ")])]}},{key:"opt",fn:function(ref){
            var row = ref.row;
return [(
          row.isTransferDispatch === 'N' ||
            (row.isTransferDispatch === 'Y' && row.uploadReceiptFlag === 'Y')
        )?_c('div',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":row.bizStatus === '3' ? '上传回单' : '修改回单',"placement":"top"}},[_c('i',{staticClass:"el-icon-tickets tool-btn",on:{"click":function($event){return _vm.$emit('uploadPod', row)}}})])],1):_vm._e()]}},{key:"orderNo",fn:function(ref){
        var row = ref.row;
return [_c('div',[_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.openOrderDetailPage(row.orderNo)}}},[_vm._v(" "+_vm._s(row.orderNo)+" ")])],1)]}}],null,true)},[_vm._v(" > ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }